import entity from 'locales/ja/entity.json';
import enumTrans from 'locales/ja/enum.json';
import translation from 'locales/ja/translation.json';
import validation from 'locales/ja/validation.json';
import field from 'locales/ja/field.json';
import message from 'locales/ja/message.json';

export default { entity, enum: enumTrans, translation, validation, field, message };
